module.exports = __webpack_public_path__ + "static/img/kugou.c7f69ab8.jpg";